module.exports = "pegasus/assets/precision-logo.png";